
import React from "react";
import { motion } from "framer-motion";

interface InlineLoaderProps {
  text: string;
}

const InlineLoader: React.FC<InlineLoaderProps> = ({ text }) => {
  return (
    <div className="flex items-center gap-2 py-3">
      {/* Small holy light animation */}
      <div className="relative">
        <motion.div
          className="absolute inset-0 rounded-full bg-heaven-gold/20 blur-sm"
          animate={{ scale: [1, 1.3, 1] }}
          transition={{ repeat: Infinity, duration: 2 }}
        />
        <motion.div
          className="h-4 w-4 rounded-full bg-heaven-gold/60"
          animate={{ opacity: [0.4, 0.7, 0.4] }}
          transition={{ repeat: Infinity, duration: 1.5, ease: "easeInOut" }}
        />
      </div>
      
      <motion.span
        className="text-sm text-heaven-gold"
        animate={{ opacity: [0.7, 1, 0.7] }}
        transition={{ repeat: Infinity, duration: 1.5, ease: "easeInOut" }}
      >
        {text}
      </motion.span>
    </div>
  );
};

export default InlineLoader;

// Also add the named export to fix the import issue
export { InlineLoader };
